import services from "@/services"
import moment from 'moment';

const state  = {
    items : [],
    data : {}
}

const getters = {
    //refundsItems: state => state.items,
    refundsItems: (state) => {
        let groupRefunds = state.items.map((x) => {
          if(x.RefundDate == "0001-01-01T00:00:00Z"){
            x.RefundDate = "" 
          }
          else if(x.RefundDate != "0001-01-01T00:00:00Z"){
            x.RefundDate = moment(String(x.RefundDate)).format('DD MMM YYYY HH:mm'); 
          }

          if(x.RejectDate == "0001-01-01T00:00:00Z"){
            x.RejectDate = "" 
          }
          else if(x.RejectDate != "0001-01-01T00:00:00Z"){
            x.RejectDate = moment(String(x.RejectDate)).format('DD MMM YYYY HH:mm');
          }
          x.actions = {
            id: x.id,
            refund: 'disable',
            reject: "enable",
            edit: "disable",
            delete: "disable",
          };
          if(x.OrderSellerRefundStatus == "PENDING"){
            x.actions.refund = 'enable'
          }
          x.PaidDate = moment(String(x.PaidDate)).format('DD MMM YYYY HH:mm');
          x.CancelDate = moment(String(x.CancelDate)).format('DD MMM YYYY HH:mm');

          return x;
        });
        return groupRefunds;
      },
    refundsDetail: state => state.data
}

const mutations = {
    setRefundsItems: (state,items) => {
        state.items = items
    },
    setRefundsItemsCsv: (state,items) => {
        state.items = items
    },
}

const actions = {
    getAll({ commit, dispatch }, param) {
        services.setHeader()
        dispatch("setLoadingTable", true, { root: true })
        return new Promise((resolve , reject) => {
            services.get('ordersellerrefund',param).then((response) => {
                commit('setRefundsItems',response.data.data.items)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
              dispatch("setLoadingTable", false, { root: true })
            })
        })
    },
    exportCsv({ commit, dispatch }, param) {
        param.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        services.setHeader()
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve , reject) => {
            services.get('ordersellerrefundcsv',param).then((response) => {
                commit('setRefundsItemsCsv',response.data.data.file)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
              dispatch("setLoadingGlobal", false, { root: true })
            })
        })
    },
    show({commit, dispatch}, id) {
      services.setHeader();
      dispatch("setLoadingGlobal", true, { root: true })
      return new Promise((resolve, reject) => {
        services
          .get(`ordersellerrefund/${id}`)
          .then((response) => {
            commit('setRefundDetail', response.data.data)
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          }).finally(()=>{
            dispatch("setLoadingGlobal", false, { root: true })
          })
      });
    },
    approve({dispatch}, body) {
        services.setHeader();
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve, reject) => {
          services
            .post("ordersellerrefundrefund", body)
            .then((response) => {
              resolve();
            })
            .catch((error) => {
              reject(error);
            }).finally(()=>{
              dispatch("setLoadingGlobal", false, { root: true })
            })
        });
      },
      reject({dispatch}, body) {
        services.setHeader();
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve, reject) => {
          services
            .post("ordersellerrefundreject", body)
            .then(() => {
              resolve();
            })
            .catch((error) => {
              reject(error);
            }).finally(()=>{
              dispatch("setLoadingGlobal", false, { root: true })
            })
        });
      },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
